import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../../assets/img/icons/search.svg'
import _imports_1 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "row mb-40" }
const _hoisted_2 = { class: "col-lg-4" }
const _hoisted_3 = { class: "form-group mb-25" }
const _hoisted_4 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_5 = ["value", "readonly"]
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "form-group mb-25" }
const _hoisted_8 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_9 = ["value", "placeholder", "readonly"]
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "form-group mb-25" }
const _hoisted_12 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { value: "" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-lg-4" }
const _hoisted_17 = { class: "form-group mb-25" }
const _hoisted_18 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_19 = ["value", "disabled"]
const _hoisted_20 = { value: "" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "col-lg-4" }
const _hoisted_23 = { class: "form-group mb-25" }
const _hoisted_24 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { value: "pending" }
const _hoisted_27 = { value: "sent" }
const _hoisted_28 = { value: "completed" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_32 = { class: "search-area style-two position-relative w-100" }
const _hoisted_33 = ["value", "placeholder"]
const _hoisted_34 = {
  key: 0,
  class: "search-results-dropdown position-absolute w-100 bg-white shadow rounded-1 mt-1 z-3"
}
const _hoisted_35 = ["disabled", "onClick"]
const _hoisted_36 = { class: "d-flex justify-content-between gap-3" }
const _hoisted_37 = { class: "fw-semibold text-title" }
const _hoisted_38 = { class: "text-muted small" }
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = { class: "fw-semibold" }
const _hoisted_41 = { class: "small text-muted" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "text-danger ms-1"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "card border-0 shadow-none rounded-1 mb-30" }
const _hoisted_46 = { class: "card-body p-xl-40" }
const _hoisted_47 = { class: "fs-18 mb-35 text-title fw-semibold" }
const _hoisted_48 = { class: "table-responsive" }
const _hoisted_49 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_50 = { class: "text-title fw-normal fs-14 pt-0 ps-0 ls-1" }
const _hoisted_51 = { class: "text-title fw-normal fs-14 pt-0 ls-1" }
const _hoisted_52 = { class: "text-title fw-normal fs-14 pt-0 ls-1" }
const _hoisted_53 = { class: "text-title fw-normal fs-14 pt-0 ls-1" }
const _hoisted_54 = { class: "text-title fw-normal fs-14 pt-0 ls-1" }
const _hoisted_55 = { class: "text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0" }
const _hoisted_56 = { class: "fs-14 fw-normal text-paragraph ps-0" }
const _hoisted_57 = { class: "fs-14 fw-normal text-paragraph" }
const _hoisted_58 = { class: "fs-14 fw-normal text-paragraph" }
const _hoisted_59 = { class: "fs-14 fw-normal text-paragraph" }
const _hoisted_60 = { class: "d-flex align-items-center" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["value", "onInput"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "fs-14 fw-normal text-paragraph" }
const _hoisted_65 = { class: "text-end pe-0" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { key: 0 }
const _hoisted_68 = {
  colspan: "6",
  class: "text-center p-4 text-muted"
}
const _hoisted_69 = { class: "row mb-40" }
const _hoisted_70 = { class: "col-lg-8" }
const _hoisted_71 = { class: "form-group mb-25" }
const _hoisted_72 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_73 = ["value", "placeholder"]
const _hoisted_74 = { class: "row" }
const _hoisted_75 = { class: "col-md-6" }
const _hoisted_76 = { class: "form-group mb-25" }
const _hoisted_77 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_78 = { class: "input-group" }
const _hoisted_79 = ["value"]
const _hoisted_80 = ["value"]
const _hoisted_81 = { class: "col-md-6" }
const _hoisted_82 = { class: "form-group mb-25" }
const _hoisted_83 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_84 = { class: "input-group" }
const _hoisted_85 = ["value"]
const _hoisted_86 = ["value"]
const _hoisted_87 = { class: "col-md-6" }
const _hoisted_88 = { class: "form-group mb-25" }
const _hoisted_89 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_90 = { class: "input-group" }
const _hoisted_91 = ["value"]
const _hoisted_92 = { class: "col-lg-4" }
const _hoisted_93 = { class: "card border-0 rounded-1 p-4 mb-4" }
const _hoisted_94 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_95 = { class: "fs-14" }
const _hoisted_96 = { class: "fs-14 fw-bold" }
const _hoisted_97 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_98 = { class: "fs-14" }
const _hoisted_99 = { class: "fs-14 fw-semibold" }
const _hoisted_100 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_101 = { class: "fs-14" }
const _hoisted_102 = { class: "fs-14 fw-semibold text-danger" }
const _hoisted_103 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_104 = { class: "fs-14" }
const _hoisted_105 = { class: "fs-14 fw-semibold" }
const _hoisted_106 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_107 = { class: "fs-14" }
const _hoisted_108 = { class: "fs-14 fw-semibold" }
const _hoisted_109 = { class: "d-flex justify-content-between mb-2 border-top pt-2" }
const _hoisted_110 = { class: "fs-18 fw-bold" }
const _hoisted_111 = { class: "fs-18 fw-bold text-primary" }
const _hoisted_112 = ["disabled"]
const _hoisted_113 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.$emit('submit')), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("quotation_page.date")), 1),
          _createElementVNode("input", {
            type: "date",
            value: _ctx.form.date,
            class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white p-3",
            readonly: _ctx.lockAutoFields,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update-field', 'date', ($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("quotation_page.reference_no")), 1),
          _createElementVNode("input", {
            type: "text",
            value: _ctx.form.reference_no,
            class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white p-3",
            placeholder: _ctx.$t('quotation_page.reference_no'),
            readonly: _ctx.lockAutoFields,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-field', 'reference_no', ($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("quotation_page.customer")), 1),
          _createElementVNode("select", {
            value: _ctx.form.customer_id ?? '',
            class: "form-select bg-white border-0 rounded-1 fs-14 text-optional h-55",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update-field', 'customer_id', _ctx.toNullableNumber($event))))
          }, [
            _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("quotation_page.select_customer")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (c) => {
              return (_openBlock(), _createElementBlock("option", {
                key: c.id,
                value: c.id
              }, _toDisplayString(c.name), 9, _hoisted_15))
            }), 128))
          ], 40, _hoisted_13)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("quotation_page.warehouse")), 1),
          _createElementVNode("select", {
            value: _ctx.form.warehouse_id ?? '',
            class: "form-select bg-white border-0 rounded-1 fs-14 text-optional h-55",
            disabled: _ctx.warehouseLockedToProfile,
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update-field', 'warehouse_id', _ctx.toNullableNumber($event))))
          }, [
            _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("quotation_page.select_warehouse")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (w) => {
              return (_openBlock(), _createElementBlock("option", {
                key: w.id,
                value: w.id
              }, _toDisplayString(w.name), 9, _hoisted_21))
            }), 128))
          ], 40, _hoisted_19)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("quotation_page.status")), 1),
          _createElementVNode("select", {
            value: _ctx.form.status,
            class: "form-select bg-white border-0 rounded-1 fs-14 text-optional h-55",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update-field', 'status', ($event.target as HTMLSelectElement).value)))
          }, [
            _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t("quotation_page.status_pending")), 1),
            _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t("quotation_page.status_sent")), 1),
            _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.$t("quotation_page.status_completed")), 1)
          ], 40, _hoisted_25)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("quotation_page.choose_product")), 1),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("input", {
              type: "text",
              value: _ctx.searchQuery,
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update-search', ($event.target as HTMLInputElement).value))),
              placeholder: _ctx.$t('quotation_page.scan_search_product'),
              class: "w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white"
            }, null, 40, _hoisted_33),
            _cache[13] || (_cache[13] = _createElementVNode("button", {
              type: "button",
              class: "bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-2"
            }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Image"
              })
            ], -1)),
            (_ctx.showResults && _ctx.searchResults.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p.id,
                      type: "button",
                      disabled: !p.canSelect,
                      onClick: ($event: any) => (_ctx.$emit('add-product', p)),
                      class: _normalizeClass(["result-item w-100 text-start border-0 bg-transparent", { 'result-item-disabled': !p.canSelect }])
                    }, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_37, _toDisplayString(p.name), 1),
                          _createElementVNode("div", _hoisted_38, _toDisplayString(p.code), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, "$" + _toDisplayString(Number(p.price || 0).toFixed(2)), 1),
                          _createElementVNode("div", _hoisted_41, [
                            (Number(p.type ?? 1) === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("quotation_page.stock")) + ": " + _toDisplayString(p.stock) + " ", 1),
                                  (!p.canSelect)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, "(" + _toDisplayString(_ctx.$t("quotation_page.out_of_stock")) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t("quotation_page.service_item")), 1))
                          ])
                        ])
                      ])
                    ], 10, _hoisted_35))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("h6", _hoisted_47, _toDisplayString(_ctx.$t("quotation_page.selected_products_for_quotation")), 1),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("table", _hoisted_49, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t("quotation_page.product")), 1),
                _createElementVNode("th", _hoisted_51, _toDisplayString(_ctx.$t("quotation_page.code")), 1),
                _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.$t("quotation_page.unit_price")), 1),
                _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.$t("quotation_page.quantity")), 1),
                _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$t("quotation_page.subtotal")), 1),
                _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.$t("quotation_page.delete")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.items, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `${item.product_id}-${index}`
                }, [
                  _createElementVNode("td", _hoisted_56, _toDisplayString(item.product_name), 1),
                  _createElementVNode("td", _hoisted_57, _toDisplayString(item.product_code), 1),
                  _createElementVNode("td", _hoisted_58, "$" + _toDisplayString(Number(item.unit_price || 0).toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.$emit('update-qty', index, -1)),
                        class: "btn btn-sm btn-outline-secondary"
                      }, "-", 8, _hoisted_61),
                      _createElementVNode("input", {
                        type: "number",
                        value: item.quantity,
                        class: "form-control form-control-sm mx-2 text-center",
                        style: {"width":"60px"},
                        onInput: ($event: any) => (_ctx.$emit('set-qty', index, Number(($event.target as HTMLInputElement).value)))
                      }, null, 40, _hoisted_62),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.$emit('update-qty', index, 1)),
                        class: "btn btn-sm btn-outline-secondary"
                      }, "+", 8, _hoisted_63)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_64, " $" + _toDisplayString((Number(item.unit_price || 0) * Number(item.quantity || 0)).toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_65, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      class: "delete-btn cursor-pointer",
                      onClick: ($event: any) => (_ctx.$emit('remove-item', index))
                    }, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: "Image"
                      }, null, -1)
                    ]))], 8, _hoisted_66)
                  ])
                ]))
              }), 128)),
              (_ctx.form.items.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_67, [
                    _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.$t("quotation_page.no_products_selected")), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t("quotation_page.note")), 1),
          _createElementVNode("textarea", {
            value: _ctx.form.note,
            class: "form-control",
            rows: "4",
            placeholder: _ctx.$t('quotation_page.optional_notes'),
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update-field', 'note', ($event.target as HTMLTextAreaElement).value)))
          }, null, 40, _hoisted_73)
        ]),
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("quotation_page.order_tax")), 1),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("input", {
                  type: "number",
                  value: _ctx.form.tax,
                  class: "form-control shadow-none fs-14 bg-white rounded-start text-title",
                  placeholder: "0",
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update-field', 'tax', Number(($event.target as HTMLInputElement).value))))
                }, null, 40, _hoisted_79),
                _createElementVNode("select", {
                  value: _ctx.form.tax_type,
                  class: "form-select shadow-none fs-14 bg-light text-title totals-type-select",
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update-field', 'tax_type', ($event.target as HTMLSelectElement).value)))
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("option", { value: "fixed" }, "$", -1),
                  _createElementVNode("option", { value: "percentage" }, "%", -1)
                ]))], 40, _hoisted_80)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t("quotation_page.order_discount")), 1),
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("input", {
                  type: "number",
                  value: _ctx.form.discount,
                  class: "form-control shadow-none fs-14 bg-white rounded-start text-title",
                  placeholder: "0",
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update-field', 'discount', Number(($event.target as HTMLInputElement).value))))
                }, null, 40, _hoisted_85),
                _createElementVNode("select", {
                  value: _ctx.form.discount_type,
                  class: "form-select shadow-none fs-14 bg-light text-title totals-type-select",
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update-field', 'discount_type', ($event.target as HTMLSelectElement).value)))
                }, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("option", { value: "fixed" }, "$", -1),
                  _createElementVNode("option", { value: "percentage" }, "%", -1)
                ]))], 40, _hoisted_86)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t("quotation_page.shipping_cost")), 1),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("input", {
                  type: "number",
                  value: _ctx.form.shipping,
                  class: "form-control shadow-none fs-14 bg-white rounded-start text-title",
                  placeholder: "0",
                  onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('update-field', 'shipping', Number(($event.target as HTMLInputElement).value))))
                }, null, 40, _hoisted_91),
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "input-group-text shipping-addon fs-16 fw-semibold" }, "$", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.$t("quotation_page.total_items")) + ":", 1),
            _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.totalItems), 1)
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t("quotation_page.subtotal")) + ":", 1),
            _createElementVNode("span", _hoisted_99, "$" + _toDisplayString(_ctx.totalCost.toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.$t("quotation_page.discount")) + ":", 1),
            _createElementVNode("span", _hoisted_102, "-$" + _toDisplayString(_ctx.calculatedDiscount.toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.$t("quotation_page.tax")) + ":", 1),
            _createElementVNode("span", _hoisted_105, "$" + _toDisplayString(_ctx.calculatedTax.toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.$t("quotation_page.shipping")) + ":", 1),
            _createElementVNode("span", _hoisted_108, "$" + _toDisplayString(Number(_ctx.form.shipping || 0).toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.$t("quotation_page.grand_total")) + ":", 1),
            _createElementVNode("span", _hoisted_111, "$" + _toDisplayString(_ctx.grandTotal.toFixed(2)), 1)
          ])
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary w-100 py-3 fw-bold",
          disabled: _ctx.isSubmitting || _ctx.form.items.length === 0
        }, [
          (_ctx.isSubmitting)
            ? (_openBlock(), _createElementBlock("span", _hoisted_113))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.isEditMode ? _ctx.$t("quotation_page.update_quotation") : _ctx.$t("create_quotation")), 1)
        ], 8, _hoisted_112)
      ])
    ])
  ], 32))
}